import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as fundebug from "fundebug-javascript";
import fundebugVue from "fundebug-vue";
require ('fundebug-revideo');
fundebug.apikey = "eaab920de0f892457530ad410efbd86d938fec0bba73ebd82a153520f2141e04"
fundebugVue(fundebug, Vue);
import {test} from '../static/js/testAddress.js'
import {product} from '../static/js/productionAddress.js'
// import "./mock/index"
// 引入axios配置
import axios from './plugins/axios'
import './plugins/element'
import {constants} from '../static/js/constants.js'
import {forMateTime,hasLogin} from '../static/js/util.js'
//the vue analytics
import VueAnalytics from 'vue-analytics';

Vue.prototype.$axios = axios
Vue.prototype.forMateTime = forMateTime
Vue.prototype.hasLogin = hasLogin
Vue.prototype.$Constans = constants
Vue.config.productionTip = false
/**钩子函数，当未登录时候不允许在浏览器直接输入路由地址进行跳转**/
axios.defaults.baseUR=process.env.VUE_APP_Axios_baseURL
console.log('当前环境的url是:',process.env.VUE_APP_Axios_baseURL);
console.log('当前环境是:',process.env.NODE_ENV);
if(process.env.NODE_ENV=='production'){
  product.uploadUrl = process.env.VUE_APP_Upload_baseURL + test.uploadUrl
  product.loginToken = process.env.VUE_APP_SSO_baseURL + product.loginToken
  console.log(product)
  Vue.prototype.$URL = product
  redirectRequest()
}else{
  test.uploadUrl = process.env.VUE_APP_Upload_baseURL + test.uploadUrl
  console.log(test)
  Vue.prototype.$URL = test
}
console.log('url',Vue.prototype.$URL)

function redirectRequest(){//用户输入http地址时将http转为https
  var targetProtocol = "https:";
  if (window.location.protocol != targetProtocol)
    window.location.href = targetProtocol + window.location.href.substring(window.location.protocol.length);
}

router.beforeEach((to, from, next) => {
  console.log('钩子函数的路由',to)
  //注册页面不拦截,作为管理员查看的的时候路由不拦截,选择注册页面不拦截
  if(to.path === '/apply'||(to.query.model=='review'&&to.query.verify)||to.path==='/selectApplyPage'||to.path==='/loginToken'){
    next()
    return
  }
  //用户没有登陆则需要跳转到登录页
  let isLogin = hasLogin()
  if (!isLogin && to.path !== '/login') {
    next('/login');
  } else {
    if (to.meta.title) {
      document.title = to.meta.title
    }
      next();
  }
})

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'G-Q2J8412VPX',
  //id: 'G-F679HXDNEC',
  router
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
